import { render, staticRenderFns } from "./SuratSakitBody.vue?vue&type=template&id=2c59d6b1&"
import script from "./SuratSakitBody.vue?vue&type=script&lang=js&"
export * from "./SuratSakitBody.vue?vue&type=script&lang=js&"
import style0 from "./SuratSakitBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports